// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3Wrwp","footer":"ModalError_footer__1R4Fe"};